export default {
  title: "",
  subtitle: "Getting Exchange Rates (FX)",
  path: "exchange_rates",
  paragraphs: [
    "This endpoint will return 3 rates, for the foreign currencies we offer (USD, EUR, AUD, CAD, CHF, JPY, CNY, GBP) and the local currencies (BRL, MXN, COP), and you can check the values for that moment, where:", 
    "brlusd is the rate for BRL – USD operations (already including the IOF and FX margin negotiated)",
    "usdbrl is the rate for USD – BRL operations (already including IOF and FX margin negotiated)",
    "brlusdspot is the current spot rate (without margin or IOF)."
  ],
  request: {
    method: "GET",
    endpoint: "/exchange_rates",
    responses: {
      "data": {
        "brlusd": "5.70243",
        "brlusdspot": "5.62460000",
        "usdbrl": "5.54719"
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Exchange/ExchangeRates.js